// Generated by Babel
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.encode = encode;
/* global: window */

var _window = window;
var btoa = _window.btoa;
function encode(data) {
  return btoa(unescape(encodeURIComponent(data)));
}

var isSupported = exports.isSupported = "btoa" in window;


//////////////////
// WEBPACK FOOTER
// ./~/tus-js-client/lib.es5/browser/base64.js
// module id = 992
// module chunks = 0